import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import useLanguage from '@comp/Question/useLanguage';
import {
  getCurrentQuestionInfo,
  getCurrentQuestion,
  getSelectedLanguage,
  getCurrentSessionUID,
  getAvailableLanguages,
  getQuizDetails
} from '@selectors/quizTaking';
import { sendViewedQuestion } from '@actions/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getIsTestRevampGoal } from '@api/selectors/constants';
import useConstants from '@api/hooks/useConstants';

const useQuestion = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();
  const { quizUID } = query;

  const selectedLanguage = useSelectorWithShallowEqual(getSelectedLanguage);
  const currentSessionUID = useSelectorWithShallowEqual(getCurrentSessionUID);
  const currentQuestion = useSelectorWithShallowEqual(getCurrentQuestion);
  const allAvailableLanguages = useSelectorWithShallowEqual(
    getAvailableLanguages
  );
  const { sectionUID, questionUID } = useSelectorWithShallowEqual(
    getCurrentQuestionInfo
  );
  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const isRevampedTestVersion2 = useConstants(
    getIsTestRevampGoal(quizDetails.goal_uid)
  );
  const { currentLanguage, onLanuguageChange, contentLanguages } = useLanguage({
    content: currentQuestion.content,
    defaultLanguage: selectedLanguage,
    availableLanguages: allAvailableLanguages
  });

  const handleOnQuestionView = () => {
    dispatch(
      sendViewedQuestion({
        quizUID,
        sessionUID: currentSessionUID,
        questionUID,
        sectionUID,
        isRevampedTestVersion2
      })
    );
  };

  return {
    sectionUID,
    questionUID,
    currentQuestion,
    currentLanguage,
    contentLanguages,
    handleLanguageChange: onLanuguageChange,
    handleOnQuestionView
  };
};

export default useQuestion;
